const appConfig = {
  name: 'Promotion Admin Portal',
  version: '2025 © Castles Technology Co., Ltd. | Promotion Ver: v1.7.0',

  // minutes
  sessionTimeout: process.env.REACT_APP_SESSIONTIMEOUT || 120,
};

export default appConfig;
